import {
  Box,
  Button
} from '@mui/material';
import { CustomIcons } from 'modules';
import React from 'react';



export type IconsProps = {};

export const Icons = (props: IconsProps) => {

  return (
    <Box display='flex'>
      <CustomIcons.MediumIcon.FC icon='SETTINGS' />
      <CustomIcons.LargeIcon.FC icon='COMPANYLOGOFULL' />
    </Box>
  );
};
